import { useTranslate } from '@tolgee/react'
import { useExceptionMessageHandler } from '@yard/utils/useExceptionMessageHandler'

export const useAllocationRulesMessageHandler = () => {
  const { t } = useTranslate()
  const { getExceptionMessage } = useExceptionMessageHandler()

  const getGlobalRulesSuccessMessage = () => {
    return t('globalRulesUpdatedSuccesfully', 'Global rules saved successfully')
  }

  const getCarrierVisitRulesSuccessMessage = () => {
    return t('carrierVisitRulesUpdatedSuccesfully', 'Carrier visit rules saved successfully')
  }

  return {
    getExceptionMessage,
    getGlobalRulesSuccessMessage,
    getCarrierVisitRulesSuccessMessage,
  }
}
